import { useMemo, useState } from "react"
import { getIn, useFormikContext } from "formik"
import { HiTrash } from "react-icons/hi"
import { AvailableVehicleRegisterTypesFormik } from "../../../../../forms/fields/AvailableVehicleRegisterTypesFormik"
import { UploadDocumentFieldFormik } from "../../../../../forms/fields/UploadDocumentFieldFormik"
import PopUpDelete from "../../../../../../../../common/components/layout/partials/PopupDelete"
import { UploadImageField } from "../../../../../../../../common/components/form/UploadImageField/UploadImageField"


type RegisterRowProps = {
  name: string
  initialData: { type: string, content: string }
  onRemoveClick?: (name: string) => void
  prefix: string
}

export function ImageBondVehicleRenterRow(props: RegisterRowProps) {
  const { values } = useFormikContext();
  const vehicle = getIn(values, 'vehicle')
  const pathToUpload = useMemo(() => `vehicles/${vehicle?._id}/${props.prefix}`, [vehicle, props.prefix])
  const [showPopup, setShowPopup] = useState(false);


  const handlePopUpOpen = () => {
    setShowPopup(true)
  }

  const handlePopUpConfirm = () => {
    props.onRemoveClick && props.onRemoveClick(props.name)
    handlePopUpClose()
  }
  const handlePopUpClose = () => {
    setShowPopup(false);
  }
  return (
    <div className="document-row grid grid-cols-1 md:grid-cols-5 items-center mg:w-1">
      <AvailableVehicleRegisterTypesFormik
        className="col-span-3"
        name={`${props.name}.type`}
      />

      <UploadDocumentFieldFormik name={`${props.name}.content`} pathToUpload={pathToUpload}>
        {({ src, onNewFile, onRemoveClick }) => (
          <UploadImageField
            src={src}
            onNewFile={onNewFile}
            onRemoveClick={onRemoveClick}
          />
        )}
      </UploadDocumentFieldFormik>

      <div className="flex justify-end">
        <button onClick={() => handlePopUpOpen()} type="button" className="bg-redPrimary hover:bg-redPrimary/80 rounded-full text-white w-[40px] h-[40px] flex justify-center items-center p-2">
          <HiTrash />
        </button>
      </div>
      {showPopup && <PopUpDelete
        disabled={false}
        onConfirm={handlePopUpConfirm}
        onClose={handlePopUpClose} />}
    </div>
  )
}